// routes/useProviderPaths.ts
import { pathsByType } from "./makePaths";
import type { ProviderType } from "./routeTypes";

export function useProviderPaths(currentProviderType: string) {
  return pathsByType[currentProviderType as ProviderType];
}
